
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import GamePlay from "../modules/gamePlay/GamePlay";
// import TestGamePlay from "../modules/gamePlay/TestGamePlay";
export default GamePlay;
// export default function Game() {
//   return <GamePlay />;
// }

    async function __Next_Translate__getStaticProps__19db5234b8c__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/game',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19db5234b8c__ as getStaticProps }
  